import { Routes } from '@angular/router';
import {
  DeclarationQueueTypeCodes,
  EDeclarationRoutes,
  ERoutes,
} from './constants/routes.constants';
import { UzuNavMenuComponent } from './components/nav-menu/uzu-nav-menu.component';
import { FeaturePlaceholderComponent } from './components/featute-placeholder/feature-placeholder.component';
import { AuthGuard } from './services/guard/auth.guard';
import { RoleGuard } from './services/guard/role.guard';

export const ROUTES: Routes = [
  {
    path: '',
    component: UzuNavMenuComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canMatch: [RoleGuard],
        data: {
          roles: ['view-housing'],
        },
        children: [
          {
            path: '',
            redirectTo: EDeclarationRoutes.APPLICANTS,
            pathMatch: 'full',
          },
          {
            path: EDeclarationRoutes.DEFAULT,
            redirectTo: EDeclarationRoutes.APPLICANTS,
          },
          {
            path: EDeclarationRoutes.APPLICANTS,
            loadChildren: () =>
              import('./modules/declaration/applicants.routes').then(
                (m) => m.HOUSING_APPLICANTS_ROUTES
              ),
            canMatch: [RoleGuard],
            data: {
              roles: ['view-housing'],
            },
          },
          {
            path: EDeclarationRoutes.POOR_FAMILIES,
            loadChildren: () =>
              import('./modules/declaration/applicants.routes').then(
                (m) => m.HOUSING_LOW_INCOME_ROUTES
              ),
          },
          {
            path: '',
            data: { breadcrumb: 'Очередь' },
            children: [
              {
                path: EDeclarationRoutes.HOUSING_QUEUE,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.HOUSING_QUEUE_ROUTES
                  ),
              },
              {
                path: EDeclarationRoutes.HOUSING_FAR_NORTH,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.HOUSING_FAR_NORTH_ROUTES
                  ),
              },
              {
                path: EDeclarationRoutes.HOUSING_CHERNOBYL,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.HOUSING_CHERNOBYL_ROUTES
                  ),
              },
              {
                path: EDeclarationRoutes.HOUSING_FORCED_MIGRATION,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.HOUSING_FORCED_MIGRATION_ROUTES
                  ),
              },
              {
                path: EDeclarationRoutes.HOUSING_YOUNG_FAMILIES,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.HOUSING_YOUNG_FAMILIES_ROUTES
                  ),
              },
            ],
          },
          {
            path: EDeclarationRoutes.HOUSING_ARCHIVE,
            loadChildren: () =>
              import('./modules/declaration/applicants.routes').then(
                (m) => m.HOUSING_ARCHIVE_ROUTES
              ),
            data: {
              declarationType: DeclarationQueueTypeCodes.HOUSING_ARCHIVE,
            },
          },
        ],
      },
      {
        path: '',
        canMatch: [RoleGuard],
        data: {
          roles: ['view-land'],
        },
        children: [
          {
            path: '',
            redirectTo: EDeclarationRoutes.APPLICANTS_LAND,
            pathMatch: 'full',
          },
          {
            path: EDeclarationRoutes.DEFAULT,
            redirectTo: EDeclarationRoutes.APPLICANTS_LAND,
          },
          {
            path: EDeclarationRoutes.APPLICANTS_LAND,
            loadChildren: () =>
              import('./modules/declaration/applicants.routes').then(
                (m) => m.LAND_APPLICANTS_ROUTES
              ),
            canMatch: [RoleGuard],
            data: {
              roles: ['view-land'],
            },
          },
          {
            path: '',
            data: { breadcrumb: 'Очередь' },
            children: [
              {
                path: EDeclarationRoutes.LAND_MAIN,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then((m) => m.LAND_MAIN_ROUTES),
              },
              {
                path: EDeclarationRoutes.LAND_FIRST_PRIORITY,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.LAND_FIRST_PRIORITY_ROUTES
                  ),
              },
              {
                path: EDeclarationRoutes.LAND_OUT_OF_TURN,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.LAND_OUT_OF_TURN_ROUTES
                  ),
              },
              {
                path: EDeclarationRoutes.LAND_ARCHIVE,
                loadChildren: () =>
                  import('./modules/declaration/applicants.routes').then(
                    (m) => m.LAND_ARCHIVE_ROUTES
                  ),
                data: {
                  declarationType: DeclarationQueueTypeCodes.LAND_ARCHIVE,
                },
              },
            ],
          },
        ],
      },
      {
        path: '',
        data: { breadcrumb: 'Справочники' },
        children: [
          {
            path: ERoutes.STREETS,
            loadChildren: () =>
              import('./modules/streets/streets-table/streets.routes').then(
                (m) => m.STREETS_ROUTES
              ),
          },
          {
            path: ERoutes.TYPE_DECLARATION_CONTENT,
            loadChildren: () =>
              import(
                './modules/type-declaration-content/type-declaration-content-table/type-declaration-content.routes'
              ).then((m) => m.TYPE_DECLARATION_CONTENT_ROUTES),
          },
          {
            path: ERoutes.TYPE_BENEFIT,
            loadChildren: () =>
              import('./modules/type-benefit/type-benefit-table/type-benefit.routes').then(
                (m) => m.TYPE_BENEFIT_ROUTES
              ),
          },
          {
            path: ERoutes.TYPE_REFUSAL,
            loadChildren: () =>
              import('./modules/type-refusal/type-refusal-table/type-refusal.routes').then(
                (m) => m.TYPE_REFUSAL_ROUTES
              ),
          },
          {
            path: ERoutes.DOCUMENT_ISSUER,
            loadChildren: () =>
              import('./modules/document-issuer/document-issuer-table/document-issuer.routes').then(
                (m) => m.DOCUMENT_ISSUER_ROUTES
              ),
          },
          {
            path: ERoutes.DECLARATION_SOURCE,
            loadChildren: () =>
              import(
                './modules/declaration-source/declaration-source-table/declaration-source.routes'
              ).then((m) => m.DECLARATION_SOURCE_ROUTES),
          },
          {
            path: ERoutes.ACCIDENT_RATE,
            loadChildren: () =>
              import('./modules/accident-rate/accident-rate-table/accident-rate.routes').then(
                (m) => m.ACCIDENT_RATE_ROUTES
              ),
          },
          {
            path: ERoutes.TYPE_AMENITY,
            loadChildren: () =>
              import('./modules/type-amenity/type-amenity-table/type-amenity.routes').then(
                (m) => m.TYPE_AMENITY_ROUTES
              ),
          },
          {
            path: ERoutes.TYPE_HOUSING,
            loadChildren: () =>
              import('./modules/type-housing/type-housing-table/type-housing.routes').then(
                (m) => m.TYPE_HOUSING_ROUTES
              ),
          },
        ],
      },
      {
        path: ERoutes.FEATURE_PLACEHOLDER,
        component: FeaturePlaceholderComponent,
      },
      {
        path: ERoutes.EMPLOYEE_ROLE_APPOINTMENT,
        loadChildren: () =>
          import(
            './modules/employee-role-appointment/employee-role-appointment-table/employee-role-appointment.routes'
          ).then((m) => m.EMPLOYEE_ROLE_APPOINTMENT_ROUTES),
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
